import { IconButton, Tooltip } from "@mui/material";
import { FC } from "react";
import { styled } from "@mui/styles";
import useLocales from "../../hooks/useLocales";

interface IListPreviewButton {
  href: any;
}

const PreviewButton = styled(IconButton)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  color: "#853EF8",
  "&:hover": {
    backgroundColor: "transparent",
    borderColor: "#0062cc",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#0062cc",
    borderColor: "#005cbf",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

const ListPreviewButton: FC<IListPreviewButton> = ({ href }) => {
  const { translate } = useLocales();
  return (
    <Tooltip title={translate("actions.preview")}>
      <a
        href={"http://www.africau.edu/images/default/sample.pdf"}
        rel="noopener noreferrer"
        download
        target="_blank"
      >
        <PreviewButton>
          <i className="icon-remove_red_eye"></i>
        </PreviewButton>
      </a>
    </Tooltip>
  );
};

export default ListPreviewButton;
